import { Route } from '@angular/router';
import { SbIcons } from '@ngx-seatback/icons';

import { TemplateDatasetEntriesComponent } from '../../../../../pages/media/template-dataset-entries/template-dataset-entries.component';
import { TemplateDatasetEntryEditComponent } from '../../../../../pages/media/template-dataset-entries/template-dataset-entry-edit/template-dataset-entry-edit.component';
import { RoutingID } from '../../../../sb-routing-enum';

export const templateDatasetEntries: Route = {
  path: ':templateDatasetID/template-dataset-entries',
  title: 'nav.templateDatasetEntries',
  data: {
    icon: SbIcons.template,
    breadcrumb: 'nav.templateDatasetEntries',
    id: RoutingID.templateDatasets,
  },
  children: [
    {
      path: '',
      component: TemplateDatasetEntriesComponent,
      data: {
        id: RoutingID.templateDatasetEntries,
        breadcrumb: '',
      },
    },
    {
      path: 'template-dataset-entry-edit/:templateDatasetEntryID',
      title: 'nav.templateDatasetEntries.edit',
      data: {
        breadcrumb: 'nav.templateDatasetEntries.edit',
        icon: SbIcons.edit,
        id: RoutingID.templateDatasetEntryEdit,
      },
      children: [
        {
          path: '',
          component: TemplateDatasetEntryEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'template-dataset-entry-create',
      title: 'nav.templateDatasetEntries.create',
      data: {
        breadcrumb: 'nav.templateDatasetEntries.create',
        icon: SbIcons.plus,
        id: RoutingID.templateDatasetEntryCreate,
      },
      children: [
        {
          path: '',
          component: TemplateDatasetEntryEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
  ],
};
